import * as React from "react";
import { PropsType } from "../../containers/FacetContainer";
import { Store } from "dw_azsearchstore";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { Translation } from 'react-i18next';

export type State = {
    isOpen: boolean;
};

class CheckboxFacet extends React.Component<PropsType, State> {
    constructor(props: PropsType) {
        super(props);
        if(this.props.facet.key == "SalesSteps" || this.props.facet.key == "Topic"){
            this.state = { isOpen: true };
        }
        else{
            this.state = { isOpen: false };
        }
    }

    componentDidUpdate(){
        //updating height of grid row to set boundaries of sticky scroller
        const resultsDiv = document.querySelector(".results") as HTMLElement;
        const facetBoxDiv = document.querySelector(".facetbox") as HTMLElement;
        const gridContainer = document.querySelector(".grid-container") as HTMLElement

        if (resultsDiv && gridContainer && facetBoxDiv){
            let allResultCardsHeight = 0;
            document.querySelectorAll(".item-card").forEach(el => allResultCardsHeight += (el.clientHeight + 20));
        }
    }

    render() {
        let facet = this.props.facet as Store.CheckboxFacet;
        let facetWithKey = { [facet.key]: facet };

        if (!facet || Object.keys(facet.values).length < 1) {
            return <div />;
        }

        const checkboxes = Object.keys(facet.values).map(
            (valueKey: string, index: number) => {
                const value = facet.values[valueKey];
                return (
                    <li key={index + 1}>
                        <div className="facet-checkbox-container">
                            <input
                                className="facet-checkbox"
                                id={`check_${facet.key}_${index + 1}`}
                                type="checkbox"
                                disabled={!value.enabled}
                                onChange={() => {
                                    this.props.toggleFacet(valueKey);
                                }}
                                checked={value.selected}
                            />{" "}
                            <label htmlFor={`check_${facet.key}_${index + 1}`}>
                                {<Translation>{t => t(value.value.toString())}</Translation>}
                            </label>
                        </div>
                    </li>
                );
            }
        );

        return (
            <div className="facet-container">
                <div className="facet-header">
                    <span
                        className={`facet-header-name facetKey_${facet.key}`}
                        onClick={() => {
                            this.setState({ isOpen: !this.state.isOpen });
                        }}
                    >
                        <span className="caret">
                            <FontAwesomeIcon
                                icon={this.state.isOpen ? faAngleDown  : faAngleRight}
                            />
                        </span>
                        <span>
                            {this.props.displayName}
                        </span>
                    {this.props.facet.filterClause !== "" ? (
                        <span
                            className="facet-header-clear"
                            onClick={() => {
                                this.props.resetThisFilter(facetWithKey);
                            }}
                        >
                            <Translation>{t => t('Clear')}</Translation>
                        </span>
                    ) : (
                            ""
                        )}
                    </span>
                </div>
                <div>
                    <Collapse isOpen={this.state.isOpen}>
                        <ul>{checkboxes}</ul>
                    </Collapse>
                </div>
                <hr />
            </div>
        );
    }
}

export default CheckboxFacet;
